'use strict';

var PostBookingPayment = Odigeo.Model.extend({
    defaults: {
        paymentDetails: {},
    },
});

var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new PostBookingPayment();
    }
    return instance;
};
